

































































import { rescueTask, ParamsInfo } from '@/api/rescueTask'
import { Component, Vue } from 'vue-property-decorator'
import Pagination from '@/components/Pagination/index.vue'
import { templateType, rescueTaskStatus } from '@/utils/enum/enum'
import { formatStampTime } from '@/utils/translateTime'
import { sendMessage } from '@/api/wxMessage'

@Component({
  components: {
    Pagination
  }
})

export default class Task extends Vue {
  private subTaskStatus: any[] = rescueTaskStatus
  private templateTypeArr: any[] = templateType

  private selectType: number = 0
  private paramsInfo: ParamsInfo = {
    organizationId: this.$Cookies.get('organizationId'),
    rescueTaskStatus: 0,
    pageNum: 1,
    pageSize: 10,
  }
  private listData: any[] = []
  private selectData: any[] = []
  private total: number = 0

  private created() {
    this.fetchData()
    this.queryTotal()
  }

  private fetchData() {
    rescueTask('GET', this.paramsInfo, null, '/Page').then((response: any) => {
      this.listData = response
    })
  }

  private queryTotal() {
    rescueTask('GET', this.paramsInfo, null, '/Count')
      .then((response: any) => {
        this.total = response
      })
      .catch(err => {
        console.log('catch' + err) // catch error
      })
  }

  private handleSearch() {
    this.paramsInfo.rescueTaskStatus = this.selectType
    this.paramsInfo.pageNum = 1
    this.paramsInfo.pageSize = 10
    this.fetchData()
    this.queryTotal()
  }

  // 表格里面维保类型的枚举:
  private transformValue(arr: any[], val: any) {
    let text: string = ''
    arr.forEach( (item, index) =>  {
      if (item.value === val) {
        text = item.label
      }
    })
    return text
  }

  // 时间戳转换成日期:
  private translateTime(stampTime: number) {
    if (stampTime != null) {
      return formatStampTime(stampTime)
    } else {
      return '--'
    }
  }
}
